import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=7d30774b&scoped=true&"
import script from "./SortList.vue?vue&type=script&lang=js&"
export * from "./SortList.vue?vue&type=script&lang=js&"
import style0 from "./SortList.vue?vue&type=style&index=0&id=7d30774b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d30774b",
  null
  
)

export default component.exports